export default {
	'report-shop-gross-profit': {
		id: 'report-shop-gross-profit',
		label: '门店毛利分析表',
		code: '0008_0004'
	}
}
